













import { Vue, Component, Prop } from 'vue-property-decorator'
import { Product } from '../../reusable/types'

@Component({
  components: {
  }
})
export default class ProductComponent extends Vue {
  @Prop({ required: true }) public readonly product!: Product

  public doesLogoExist = true

  get linkRoute () {
    return {
      name: 'product',
      params: {
        productTitle: this.product.title
      }
    }
  }

  public getLogoSource () {
    return (this.doesLogoExist) ? `./icons/products/${this.product.title}.png` : null
  }

  public handleLogoLoadingError () {
    this.doesLogoExist = false
  }
}
